/* ===========================================================================
   Super Cacheada — LP da loja internacional oficial dentro da MKPBR
   Vitrine, ficha do produto, carrinho proprio, seletores e faixa de mercado.

   DEGRAUS DO DESCONTO: 2 itens = 5%, 3 = 10%, 4+ = 15%, contando o TOTAL DE
   ITENS DO CARRINHO (soma produtos diferentes). Quem APLICA e o app Pumper,
   no servidor — esta pagina so mostra. Os degraus vem do #sc-cfg, e a fonte
   da verdade e a configuracao do Pumper, que o storefront nao consegue ler.

   DIFERENCA PARA A PEACH UP E A TYRREL: aqui METADE DO CATALOGO TEM VARIANTE
   (300 g / 500 g, 300 ml / 1 L, morango / pessego). Aquelas LPs assumiam um
   produto = uma variante e mandavam `p.vid` direto para o carrinho. Fazer isso
   aqui significaria escolher o aroma pela pessoa. Entao:
     - o card mostra "a partir de" quando os precos das variantes diferem;
     - o botao do card vira "escolher opcoes" e ABRE A FICHA em vez de somar;
     - a ficha tem seletor de variante, e preco, SKU e disponibilidade
       acompanham a escolha.
   =========================================================================== */
(function () {
  'use strict';

  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };

  /* ---------- dados ------------------------------------------------------ */
  function readJSON(id, fallback) {
    var el = D.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { console.error('[supercacheada] JSON invalido em #' + id, e); return fallback; }
  }
  var CFG = readJSON('sc-cfg', {});
  var RAW = readJSON('sc-data', []);

  /* O Liquid devolve numero como texto em varios campos. Converte UMA vez,
     logo depois de ler o JSON, para nao quebrar em .toFixed() la na frente. */
  function normVar(v) {
    v.pr = Number(v.pr) || 0;
    v.prf = String(v.prf == null ? '' : v.prf);
    v.cmpf = v.cmpf ? String(v.cmpf) : null;
    v.av = v.av === true || v.av === 'true';
    v.t = String(v.t == null ? '' : v.t);
    return v;
  }

  var PRODUCTS = RAW.filter(function (p) { return p && p.v && p.v.length; }).map(function (p) {
    p.v = p.v.map(normVar);
    p.img = Array.isArray(p.img) ? p.img : [];
    p.tags = Array.isArray(p.tags) ? p.tags : [];
    p.av = p.v.some(function (v) { return v.av; });
    /* preco de vitrine: o MENOR entre as variantes DISPONIVEIS; se nenhuma
       estiver disponivel, o menor de todas, so para o card nao ficar sem preco. */
    var disp = p.v.filter(function (v) { return v.av; });
    var base = (disp.length ? disp : p.v).slice().sort(function (a, b) { return a.pr - b.pr; });
    p.min = base[0];
    /* "a partir de" so quando os precos REALMENTE diferem. Morango e pessego
       custam o mesmo: ali "a partir de" seria ruido. */
    p.faixa = p.v.length > 1 && p.v.some(function (v) { return v.pr !== p.v[0].pr; });
    p.multi = p.v.length > 1;
    return p;
  });

  /* ---------- idiomas ---------------------------------------------------- */
  var DICT = (window.SC_I18N || {});
  var ISO = (CFG.iso || D.documentElement.lang || 'en');
  var PACK = DICT[ISO] || DICT[ISO.split('-')[0]] || DICT.en || {};
  var EN = DICT.en || {};
  function t(k) { return PACK[k] || EN[k] || ''; }

  function paint(root) {
    $$('[data-i18n]', root || D).forEach(function (el) {
      var v = t(el.getAttribute('data-i18n'));
      if (v) el.textContent = v;
    });
    $$('[data-i18n-aria]', root || D).forEach(function (el) {
      var v = t(el.getAttribute('data-i18n-aria'));
      if (v) el.setAttribute('aria-label', v);
    });
  }

  /* ---------- dinheiro --------------------------------------------------- */
  var CURRENCY = 'USD';
  /* Usado SO no carrinho: ali o /cart.js entrega a moeda do mercado.
     Nos cards e na ficha usamos v.prf, que o Liquid ja formatou — foi assim
     que o preco japones aparecia como "$8,900.00" em vez de iene: o Intl caia
     no dolar quando o carrinho ainda estava vazio. */
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(ISO, { style: 'currency', currency: CURRENCY }).format(n);
    } catch (e) {
      return CURRENCY + ' ' + n.toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- familias ---------------------------------------------------
     Cinco prateleiras, na ordem da ROTINA — que e como a propria marca
     organiza o menu do site oficial: lavar, tratar, couro cabeludo,
     finalizar, corpo. Um produto vive em UMA prateleira so: ao contrario da
     Peach Up, aqui nao ha kit que atravesse linhas (o unico kit de cabelo, o
     trio de mascaras, e de tratamento, e a duplinha e de lavagem).

     A classificacao e por HANDLE, que e estavel. As tags entram so como
     reserva, para produto novo que a MKPBR ative depois. */
  var FAMILIAS = ['wash', 'treat', 'scalp', 'style', 'body'];
  var POR_HANDLE = {
    'super-cacheada-shampoo-super-hidratante': 'wash',
    'super-cacheada-higienizador-super-estimulante': 'wash',
    'super-cacheada-condicionador-super-desembaracante': 'wash',
    'super-cacheada-shampoo-conditioner-kit': 'wash',

    'super-cacheada-mascara-super-inteligente-mask': 'treat',
    'super-cacheada-tratamento-super-reconstrutor': 'treat',
    'super-cacheada-tratamento-super-acidificante': 'treat',
    'super-cacheada-mask-treatment-trio-kit-three-hair-masks': 'treat',

    'super-cacheada-lama-dermocapilar-scalp-detox': 'scalp',
    'super-cacheada-oleo-dermocapilar-super-puro': 'scalp',
    'super-cacheada-tonico-dermocapilar-super-energizante': 'scalp',

    'super-cacheada-finalizador-super-definicao-cream': 'style',
    'super-cacheada-finalizador-super-nutricao': 'style',
    'geleia-super-modeladora-hair-styling-jelly': 'style',
    'super-cacheada-finalizador-super-gel-3x1': 'style',
    'super-cacheada-mousse-super-volume': 'style',
    'super-cacheada-super-perfumado-hair-oil': 'style',

    'super-cacheada-manteiga-corporal-hidratante-spa': 'body',
    'super-cacheada-esfoliante-corporal-acucarado-spa': 'body',
    'super-cacheada-oleo-corporal-super-hidraglow-spa': 'body'
  };

  /* Acessorios de cetim (toucas, xuxinhas, elastico afro puff, touca
     difusora) ficam FORA da LP por decisao do Rafael em 15/09/2026, mesmo
     estando ativos na loja. A lista e por handle para nao depender de tag. */
  var FORA = [
    'super-cacheada-double-sided-sleep-cap',
    'super-cacheada-satin-diffuser-cap',
    'super-cacheada-satin-scrunchie-5-pack',
    'super-cacheada-slim-satin-scrunchie-5-pack',
    'super-cacheada-bigger-scrunchie-5-pack',
    'super-cacheada-satin-afro-puff-hair-tie-5-pack'
  ];

  function familia(p) {
    if (FORA.indexOf(p.h) > -1) return null;
    if (POR_HANDLE[p.h]) return POR_HANDLE[p.h];
    /* Reserva por tag, para produto novo fora da lista acima. */
    var tags = p.tags.map(function (x) { return String(x).toLowerCase(); });
    if (tags.indexOf('hair accessories') > -1) return null;
    if (tags.indexOf('bath & body') > -1) return 'body';
    if (tags.indexOf('shampoo & conditioner') > -1) return 'wash';
    if (tags.indexOf('hair mask') > -1) return 'treat';
    if (tags.indexOf('hair treatment') > -1) return 'scalp';
    if (tags.indexOf('hair styling cream / gel /mousse') > -1) return 'style';
    if (tags.indexOf('hair cream / leave-in') > -1) return 'style';
    if (tags.indexOf('hair oil / serum') > -1) return 'style';
    return 'style';
  }

  /* Ordem DENTRO da prateleira, seguindo a rotina: o passo vem antes do kit,
     e o kit fecha a prateleira. Produto sem estoque vai sempre para o fim. */
  var ORDEM = [
    'super-cacheada-shampoo-super-hidratante',
    'super-cacheada-higienizador-super-estimulante',
    'super-cacheada-condicionador-super-desembaracante',
    'super-cacheada-shampoo-conditioner-kit',
    'super-cacheada-mascara-super-inteligente-mask',
    'super-cacheada-tratamento-super-reconstrutor',
    'super-cacheada-tratamento-super-acidificante',
    'super-cacheada-mask-treatment-trio-kit-three-hair-masks',
    'super-cacheada-lama-dermocapilar-scalp-detox',
    'super-cacheada-oleo-dermocapilar-super-puro',
    'super-cacheada-tonico-dermocapilar-super-energizante',
    'super-cacheada-finalizador-super-definicao-cream',
    'super-cacheada-finalizador-super-nutricao',
    'geleia-super-modeladora-hair-styling-jelly',
    'super-cacheada-finalizador-super-gel-3x1',
    'super-cacheada-mousse-super-volume',
    'super-cacheada-super-perfumado-hair-oil',
    'super-cacheada-manteiga-corporal-hidratante-spa',
    'super-cacheada-esfoliante-corporal-acucarado-spa',
    'super-cacheada-oleo-corporal-super-hidraglow-spa'
  ];
  function ordena(a, b) {
    if (a.av !== b.av) return a.av ? -1 : 1;
    var ia = ORDEM.indexOf(a.h), ib = ORDEM.indexOf(b.h);
    if (ia < 0) ia = 999; if (ib < 0) ib = 999;
    if (ia !== ib) return ia - ib;
    return a.min.pr - b.min.pr;
  }

  /* ---------- vitrine ---------------------------------------------------- */
  function precoHTML(p) {
    var v = p.min;
    var corpo = v.cmpf ? '<s>' + esc(v.cmpf) + '</s>' + esc(v.prf) : esc(v.prf);
    if (p.faixa) return '<span class="sc-card__from">' + esc(t('from')) + '</span>' + corpo;
    return corpo;
  }

  /* SELO OFICIAL da Entrega Garantida — a arte do Rafael, servida pelo tema.
     O endereco vem do #sc-cfg porque o JS nao sabe montar asset_url sozinho.
     Se o arquivo faltar, cai no escudo em SVG: melhor um escudo do que um
     retangulo quebrado ao lado da promessa mais importante da pagina. */
  var ESCUDO = '<svg class="sc-selo" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 2.6 4.6 5.4v6c0 4.4 3.1 8.5 7.4 9.9 4.3-1.4 7.4-5.5 7.4-9.9v-6L12 2.6Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M8.6 12.1l2.3 2.3 4.5-4.6" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  var SELO = CFG.seloUrl
    ? '<img class="sc-selo-img" src="' + esc(CFG.seloUrl) + '" alt="" width="860" height="900" loading="lazy">'
    : ESCUDO;

  function cardHTML(p) {
    var img = p.img[0] || {};
    /* Produto com mais de uma variante NAO soma direto: o botao leva a ficha,
       onde a pessoa escolhe o tamanho ou o aroma. Somar por conta propria
       mandaria o aroma errado — e devolucao internacional custa caro. */
    var rotulo = !p.av ? t('soldout') : (p.multi ? t('pdp_choose_card') : t('add'));
    var attr = p.multi ? ' data-sc-open-handle="' + esc(p.h) + '"' : ' data-sc-add="' + p.min.id + '"';
    return '' +
      '<div class="sc-card__img">' +
        '<img src="' + esc(img.s || '') + '" alt="' + esc(img.a || p.t) + '" loading="lazy" width="900" height="900">' +
        '<span class="sc-card__quick">' + esc(t('quick')) + '</span>' +
        (p.av ? '' : '<span class="sc-card__flag">' + esc(t('soldout')) + '</span>') +
      '</div>' +
      '<div class="sc-card__body">' +
        '<h3>' + esc(p.t) + '</h3>' +
        '<div class="sc-card__price">' + precoHTML(p) + '</div>' +
        /* Micro-selo da entrega garantida no proprio card. A duvida que trava a
           compra internacional aparece antes do clique, nao depois: aqui ela ja
           esta respondida na vitrine. */
        '<span class="sc-card__del">' + ESCUDO + esc(t('del_card')) + '</span>' +
        '<button type="button" class="sc-btn sc-btn--sm sc-btn--full sc-card__add"' + attr +
          (p.av ? '' : ' disabled') + '>' + esc(rotulo) + '</button>' +
      '</div>';
  }

  function renderGrids() {
    var buckets = {};
    FAMILIAS.forEach(function (k) { buckets[k] = []; });
    PRODUCTS.forEach(function (p) {
      var k = familia(p);
      if (k && buckets[k]) buckets[k].push(p);
    });
    FAMILIAS.forEach(function (k) {
      var grid = $('[data-sc-grid="' + k + '"]');
      if (!grid) return;
      var list = buckets[k].sort(ordena);
      if (!list.length) {
        var sec = grid.closest('.sc-shelf');
        if (sec) sec.hidden = true;
        /* Sem produto na familia, o atalho la de cima tambem sai: um chip que
           rola para uma secao escondida nao leva a lugar nenhum. */
        $$('.sc-fam[href="#' + (sec ? sec.id : '') + '"]').forEach(function (a) { a.hidden = true; });
        return;
      }
      grid.innerHTML = '';
      grid.setAttribute('aria-busy', 'false');
      list.forEach(function (p) {
        /* O card NAO pode ser um <button>: botao dentro de botao e HTML
           invalido. Uma div com role=button e tabindex=0 resolve, e o clique
           no botao de comprar e tratado ANTES do clique no card. */
        var el = D.createElement('div');
        el.className = 'sc-card' + (p.av ? '' : ' sc-card--out');
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-label', p.t);
        el.dataset.scHandle = p.h;
        el.innerHTML = cardHTML(p);
        grid.appendChild(el);
      });
      var n = $('[data-sc-count-fam="' + k + '"]');
      if (n) n.textContent = list.length;
    });
  }

  /* ---------- trava de rolagem ------------------------------------------- */
  /* Precisa travar o HTML, nao so o body: como o html tem overflow-x:clip,
     ele deixou de ser 'visible' e virou o elemento que rola. Travando so o
     body, a roda do mouse continuava rolando a LP por tras do popup. */
  var travas = 0;
  function travarRolagem() {
    travas++;
    D.documentElement.classList.add('sc-lock');
    D.body.classList.add('sc-lock');
  }
  function destravarRolagem(tudo) {
    travas = tudo ? 0 : Math.max(0, travas - 1);
    if (travas === 0) {
      D.documentElement.classList.remove('sc-lock');
      D.body.classList.remove('sc-lock');
    }
  }

  /* ---------- ficha do produto ------------------------------------------- */
  var pdpOvl, pdpBox, lastFocus = null;
  var PDP = { p: null, v: null };   /* produto e variante abertos agora */

  function bulletsHTML(txt) {
    if (!txt) return '';
    var linhas = String(txt).split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
    if (linhas.length > 1) {
      return '<ul>' + linhas.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul>';
    }
    return '<p>' + esc(linhas[0] || '') + '</p>';
  }
  function parasHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n{2,}|\n---\n/).map(function (b) {
      var l = b.trim(); if (!l) return '';
      return '<p>' + esc(l).replace(/\n/g, '<br>') + '</p>';
    }).join('');
  }
  /* "Ingredientes explicados" vem em blocos separados por ---, e cada bloco
     comeca com o NOME do ingrediente na primeira linha. Sem hierarquia, nome e
     explicacao encostam um no outro e o bloco vira parede de texto. */
  function ingHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n?---\n?/).map(function (bloco) {
      var linhas = bloco.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
      if (!linhas.length) return '';
      var nome = linhas.shift();
      return '<p><strong>' + esc(nome) + '</strong>' +
             (linhas.length ? '<br>' + linhas.map(esc).join('<br>') : '') + '</p>';
    }).join('');
  }

  function acc(key, body, open) {
    if (!body) return '';
    return '<details class="sc-acc"' + (open ? ' open' : '') + '>' +
      '<summary>' + esc(t(key)) + '</summary>' +
      '<div class="sc-acc__c">' + body + '</div></details>';
  }

  /* Card de desconto por quantidade DENTRO da ficha do produto. E o lugar onde
     a pessoa decide levar mais de um — mostrar o degrau so la embaixo na pagina
     nao ajuda quem esta com o popup aberto. Quem APLICA continua sendo o
     Pumper, no servidor; aqui e vitrine. */
  function qdHTML() {
    var passos = CFG.steps || [];
    if (!passos.length) return '';
    return '<div class="sc-pdp__qd" data-sc-pdp-qd>' +
      '<strong>' + esc(t('qd_t')) + '</strong>' +
      '<ul>' + passos.map(function (s) {
        var rot = s.q >= 4 ? t('qd_4') : t('qd_' + s.q);
        return '<li data-q="' + s.q + '"><b>' + s.p + '%</b><span>' + esc(rot) + '</span></li>';
      }).join('') + '</ul>' +
      '<small>' + esc(t('qd_d')) + ' ' + esc(t('qd_note')) + '</small>' +
    '</div>';
  }

  /* ---------- seletor de variante ----------------------------------------
     O rotulo sai do NOME DA OPCAO que o Shopify ja devolve traduzido
     ("Size", "Scent"). So quando o cadastro nao tem nome de opcao — caso de
     variante unica chamada "Default Title" — caimos no rotulo generico. */
  function optHTML(p) {
    if (!p.multi) return '';
    var rotulo = p.optName && p.optName !== 'Title' ? p.optName : t('pdp_opt');
    return '<div class="sc-opt">' +
      '<span class="sc-opt__l" id="sc-opt-l">' + esc(rotulo) + '</span>' +
      '<div class="sc-opt__list" role="group" aria-labelledby="sc-opt-l">' +
        p.v.map(function (v) {
          return '<button type="button" class="sc-opt__b" data-sc-var="' + v.id + '"' +
            ' aria-pressed="' + (PDP.v && PDP.v.id === v.id ? 'true' : 'false') + '"' +
            (v.av ? '' : ' disabled') + '>' + esc(v.t) + '</button>';
        }).join('') +
      '</div>' +
    '</div>';
  }

  /* Preco, SKU, botoes e degraus acompanham a variante escolhida. Sem isto a
     pessoa escolheria 500 g e continuaria vendo o preco do 300 g. */
  function pintarVariante() {
    var p = PDP.p, v = PDP.v;
    if (!p || !v) return;
    var preco = $('[data-sc-pdp-price]');
    if (preco) preco.innerHTML = v.cmpf ? '<s>' + esc(v.cmpf) + '</s>' + esc(v.prf) : esc(v.prf);
    var sku = $('[data-sc-pdp-sku]');
    if (sku) { sku.textContent = t('pdp_sku') + ': ' + (v.sku || '—'); sku.hidden = !v.sku; }
    $$('[data-sc-var]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(Number(b.dataset.scVar) === Number(v.id)));
    });
    $$('[data-sc-add],[data-sc-buy]', pdpBox).forEach(function (b) {
      if (b.hasAttribute('data-sc-add')) b.dataset.scAdd = v.id; else b.dataset.scBuy = v.id;
      b.disabled = !v.av;
      b.textContent = v.av ? (b.hasAttribute('data-sc-add') ? t('add') : t('buy')) : t('soldout');
    });
    var qty = $('.sc-pdp__qty');
    if (qty) qty.hidden = !v.av;
    marcarDegrausPDP();
  }

  /* ---------- quantidade dentro da ficha ---------------------------------- */
  var PDP_QTD_MAX = 10;

  function qtdHTML() {
    return '<div class="sc-pdp__qty">' +
      '<span class="sc-pdp__qty-l" id="sc-pdp-qty-l">' + esc(t('pdp_qty')) + '</span>' +
      '<span class="sc-step sc-step--lg" role="group" aria-labelledby="sc-pdp-qty-l">' +
        '<button type="button" data-sc-pdp-step="-1" aria-label="' + esc(t('c_less')) + '" disabled>&minus;</button>' +
        '<span data-sc-pdp-qtd aria-live="polite">1</span>' +
        '<button type="button" data-sc-pdp-step="1" aria-label="' + esc(t('c_more')) + '">+</button>' +
      '</span>' +
    '</div>';
  }

  /* Programa de entrega garantida da MKPBR, dentro da ficha. E aqui que a
     pessoa decide comprar, e a duvida que trava a compra internacional e
     sempre a mesma: "vou pagar taxa quando chegar?". A resposta tem de estar
     ao lado do botao, nao so numa secao la embaixo. */
  /* O QUE ABRE O POPUP, de qualquer lugar da pagina.
     E um <label for="sc-guar-cbx">, nao um <a>: o popup da garantia e comandado
     por um checkbox escondido e FUNCIONA SEM JAVASCRIPT. Label alcanca o
     checkbox de qualquer ponto do documento, entao a mesma peca serve o card,
     a ficha, o carrinho, o rodape e a faixa de confianca.
     Antes isto era <a target="_blank"> para /pages/mkpbr-guaranteed-delivery-
     program: abria OUTRA GUIA e a pessoa perdia o carrinho de vista. O link
     para a pagina completa continua existindo, mas DENTRO do popup. */
  function abreGarantia(rotulo, classe) {
    return '<label class="' + classe + '" for="sc-guar-cbx" role="button" tabindex="0">' +
      esc(t(rotulo)) + '</label>';
  }

  function entregaHTML() {
    return '<div class="sc-pdp__del">' +
      '<strong>' + SELO + '<span>' + esc(t('del_t')) + '</span></strong>' +
      '<p>' + esc(t('del_pdp')) + '</p>' +
      abreGarantia('del_c', 'sc-lnk') +
    '</div>';
  }

  function pdpQtd() {
    var el = $('[data-sc-pdp-qtd]');
    var n = el ? parseInt(el.textContent, 10) : 1;
    return (isFinite(n) && n > 0) ? Math.min(PDP_QTD_MAX, n) : 1;
  }

  function porQtdPDP(n) {
    var el = $('[data-sc-pdp-qtd]');
    if (!el) return;
    n = Math.min(PDP_QTD_MAX, Math.max(1, n));
    el.textContent = String(n);
    var menos = $('[data-sc-pdp-step="-1"]');
    var mais = $('[data-sc-pdp-step="1"]');
    if (menos) menos.disabled = n <= 1;
    if (mais) mais.disabled = n >= PDP_QTD_MAX;
    marcarDegrausPDP();
  }

  function marcarDegrausPDP() {
    var caixa = $('[data-sc-pdp-qd]');
    if (!caixa) return;
    /* O desconto do Pumper conta o carrinho INTEIRO, nao este produto. Entao
       o degrau que acende e o do que o carrinho VAI TER depois de somar a
       quantidade escolhida aqui: e isso que a pessoa vai pagar. */
    var total = CART.count + pdpQtd();
    var atingido = null;
    (CFG.steps || []).forEach(function (s) { if (total >= s.q) atingido = s; });
    $$('li', caixa).forEach(function (li) {
      li.classList.toggle('is-on', !!atingido && Number(li.dataset.q) === atingido.q);
    });
  }

  function openPDP(handle) {
    var p = PRODUCTS.filter(function (x) { return x.h === handle; })[0];
    if (!p || !pdpOvl) return;
    lastFocus = D.activeElement;

    /* Abre ja na variante disponivel mais barata — nunca numa esgotada. */
    PDP.p = p;
    PDP.v = p.min;

    var thumbs = p.img.map(function (im, i) {
      return '<button type="button" data-sc-th="' + i + '"' + (i === 0 ? ' aria-current="true"' : '') +
        '><img src="' + esc(im.s) + '" alt="" loading="lazy"></button>';
    }).join('');

    pdpBox.innerHTML = '' +
      '<button type="button" class="sc-x" data-sc-pdp-close aria-label="' + esc(t('pdp_close')) + '">&times;</button>' +
      '<div class="sc-pdp">' +
        '<div class="sc-pdp__gal">' +
          '<div class="sc-pdp__main"><img src="' + esc((p.img[0] || {}).s || '') + '" alt="' + esc((p.img[0] || {}).a || p.t) + '" data-sc-main></div>' +
          (p.img.length > 1 ? '<div class="sc-pdp__thumbs">' + thumbs + '</div>' : '') +
        '</div>' +
        '<div class="sc-pdp__info">' +
          '<h2 id="sc-pdp-t">' + esc(p.t) + '</h2>' +
          (p.ai && p.ai.tag
            ? '<p style="margin:0"><span class="sc-eyebrow" style="display:block;margin:0 0 .2rem">' + esc(t('pdp_tagline')) + '</span>' +
              '<span style="color:var(--sc-suave)">' + esc(p.ai.tag) + '</span></p>'
            : '') +
          '<div class="sc-pdp__price" data-sc-pdp-price></div>' +
          /* Ordem de proposito: escolher a variante, depois quantas leva, e o
             degrau de desconto logo abaixo acende sozinho. */
          optHTML(p) +
          qtdHTML() +
          qdHTML() +
          '<div class="sc-pdp__acts">' +
            '<button type="button" class="sc-btn sc-btn--ghost" data-sc-add=""></button>' +
            '<button type="button" class="sc-btn" data-sc-buy=""></button>' +
          '</div>' +
          entregaHTML() +
          '<div style="margin-top:.4rem">' +
            acc('pdp_purpose', bulletsHTML(p.ai && p.ai.pur), true) +
            acc('pdp_high', bulletsHTML(p.ai && p.ai.hig)) +
            acc('pdp_how', parasHTML(p.ai && p.ai.how)) +
            acc('pdp_audience', parasHTML(p.ai && p.ai.aud)) +
            acc('pdp_good', bulletsHTML(p.ai && p.ai.gtk)) +
            acc('pdp_ing', ingHTML(p.ai && p.ai.ing)) +
            acc('pdp_tog', parasHTML(p.ai && p.ai.tog)) +
            acc('pdp_desc', parasHTML(p.d)) +
          '</div>' +
          '<p class="sc-nota" style="margin:0" data-sc-pdp-sku></p>' +
        '</div>' +
      '</div>';

    pdpOvl.classList.add('is-on');
    travarRolagem();
    porQtdPDP(1);
    pintarVariante();
    var x = $('[data-sc-pdp-close]', pdpBox);
    if (x) x.focus();
  }

  function closePDP() {
    if (!pdpOvl || !pdpOvl.classList.contains('is-on')) return;
    pdpOvl.classList.remove('is-on');
    destravarRolagem();
    pdpBox.innerHTML = '';
    PDP.p = null; PDP.v = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- carrinho ---------------------------------------------------- */
  var CART = { items: [], total: 0, count: 0 };
  var cartEl, veilEl, bodyEl, footEl, totalEl, countEl, qdEl, shipEl, delEl;

  /* ---------- barra de frete da loja x carrinho da LP ---------------------
     A dock de frete da loja (#mkpbrDock) e position:fixed com z-index
     2147482000. Nenhuma camada da LP passa por cima disso sem entrar numa
     corrida de z-index contra um componente da loja. No celular, com o
     carrinho aberto, ela cobria o botao de pagar INTEIRO (medido na Peach Up
     em 14/09/2026: dock de 740 a 824 sobre um botao de 743 a 791).

     Solucao em duas metades:
       1. o CSS tira a dock de cena enquanto qualquer sobreposicao da LP
          estiver aberta (a classe sc-lock ja marca exatamente esse estado);
       2. esta funcao escreve o recado de frete DENTRO do carrinho, logo
          acima do botao.

     A linha e CALCULADA, nao copiada do texto da dock. Copiar atrasava um
     passo: a dock se redesenha sozinha depois que o carrinho muda, entao ler
     o texto dela dentro do syncCart pegava o estado ANTERIOR — quem subia ate
     portes gratis e voltava continuava vendo "portes gratis desbloqueados". */
  function espelharFrete() {
    if (!shipEl) return;
    var S = window.MKPBR_SHIP;
    if (!S || typeof S.compute !== 'function' || !CART.raw || CART.count < 1) {
      shipEl.hidden = true;
      return;
    }
    var e;
    try { e = S.compute(CART.raw); } catch (err) {
      console.error('[supercacheada] frete', err);
      shipEl.hidden = true;
      return;
    }
    if (!e) { shipEl.hidden = true; return; }

    if (e.freeReached) {
      shipEl.innerHTML = '<b>' + esc(t('ship_free')) + '</b>';
    } else if (e.faltaProximo > 0 && e.economiaProximo > 0) {
      var texto = t('ship_more')
        .replace('{v}', money(Math.round(e.faltaProximo * 100)))
        .replace('{p}', money(Math.round(e.economiaProximo * 100)));
      shipEl.innerHTML = '<b>' + esc(texto) + '</b>';
    } else {
      shipEl.hidden = true;
      return;
    }
    shipEl.hidden = false;
  }

  function cartURL(path) { return (CFG.root || '') + path; }

  /* UM lugar so para absorver um carrinho do Shopify. Na Peach Up, fetchCart e
     changeQty copiavam os campos cada um por conta propria; quando o calculo
     do frete passou a precisar do payload CRU, so o fetchCart foi atualizado e
     mexer na quantidade parou de atualizar a linha de frete. */
  function aplicarCarrinho(c) {
    if (!c) return;
    CART.items = c.items || [];
    CART.total = c.total_price || 0;
    CART.count = c.item_count || 0;
    CART.raw = c;
    if (c.currency) CURRENCY = c.currency;
    syncCart();
  }

  function fetchCart() {
    return fetch(cartURL('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { aplicarCarrinho(c); return c; })
      .catch(function (e) { console.error('[supercacheada] cart.js', e); });
  }

  function syncCart() {
    if (countEl) countEl.textContent = CART.count;
    /* A barra de frete do rodape so deve aparecer DEPOIS que existe carrinho:
       com carrinho vazio ela anunciaria um degrau para quem ainda nao escolheu
       nada. O CSS esconde o dock enquanto o body nao tem esta classe. */
    D.body.classList.toggle('sc-has-cart', CART.count > 0);
    renderCart();
    markStep();
  }

  function renderCart() {
    if (!bodyEl) return;
    if (!CART.items.length) {
      bodyEl.innerHTML =
        '<div class="sc-cart__empty">' +
          '<strong>' + esc(t('c_empty')) + '</strong>' +
          '<span>' + esc(t('c_empty_d')) + '</span>' +
          '<button type="button" class="sc-btn sc-btn--ghost sc-btn--sm" data-sc-cart-close>' + esc(t('c_empty_cta')) + '</button>' +
        '</div>';
      if (footEl) footEl.hidden = true;
      return;
    }
    bodyEl.innerHTML = CART.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      /* O titulo da variante aparece na linha: com morango e pessego no mesmo
         carrinho, sem isso as duas linhas ficariam identicas. */
      var vt = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<span class="sc-line__v">' + esc(it.variant_title) + '</span>' : '';
      return '<div class="sc-line" data-key="' + esc(it.key) + '">' +
        '<div class="sc-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="sc-line__b">' +
          '<span class="sc-line__t">' + esc(it.product_title || it.title) + '</span>' + vt +
          '<div class="sc-line__r">' +
            '<span class="sc-step">' +
              '<button type="button" data-sc-qty="-1" aria-label="' + esc(t('c_less')) + '">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-sc-qty="1" aria-label="' + esc(t('c_more')) + '">+</button>' +
            '</span>' +
            '<span class="sc-line__p">' + money(it.final_line_price != null ? it.final_line_price : it.line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="sc-line__x" data-sc-rm>' + esc(t('c_rm')) + '</button>' +
        '</div>' +
      '</div>';
    }).join('');
    if (footEl) footEl.hidden = false;
    if (totalEl) totalEl.textContent = money(CART.total);
    /* Entrega garantida DENTRO do carrinho, logo antes do aviso de operador.
       E o ultimo momento em que a pessoa pode desistir por medo de taxa na
       entrega; a resposta tem de estar aqui, nao so numa secao la em cima. */
    if (delEl && !delEl.dataset.pronto) {
      delEl.innerHTML = SELO + '<span><b>' + esc(t('del_t')) + '</b>' +
        esc(t('del_pdp')) + ' ' + abreGarantia('del_c', 'sc-lnk') + '</span>';
      delEl.dataset.pronto = '1';
    }
  }

  function markStep() {
    var atingido = null;
    (CFG.steps || []).forEach(function (s) { if (CART.count >= s.q) atingido = s; });

    $$('[data-sc-qd] .sc-qd__step').forEach(function (el) {
      el.classList.toggle('sc-qd__step--on', !!atingido && Number(el.dataset.q) === atingido.q);
    });

    marcarDegrausPDP();

    if (qdEl) {
      if (atingido) {
        var rotulo = atingido.q >= 4 ? t('qd_4') : t('qd_' + atingido.q);
        qdEl.textContent = rotulo + ' · ' + atingido.p + '% ' + t('qd_off') + ' — ' + t('qd_note');
        qdEl.hidden = false;
      } else {
        qdEl.hidden = true;
      }
    }
    espelharFrete();
  }

  function openCart() {
    if (!cartEl || cartEl.classList.contains('is-on')) return;
    cartEl.classList.add('is-on');
    cartEl.setAttribute('aria-hidden', 'false');
    if (veilEl) { veilEl.hidden = false; requestAnimationFrame(function () { veilEl.classList.add('is-on'); }); }
    travarRolagem();
    espelharFrete();
    var c = $('[data-sc-cart-close]', cartEl);
    if (c) c.focus();
  }
  function closeCart() {
    if (!cartEl || !cartEl.classList.contains('is-on')) return;
    cartEl.classList.remove('is-on');
    cartEl.setAttribute('aria-hidden', 'true');
    if (veilEl) { veilEl.classList.remove('is-on'); setTimeout(function () { veilEl.hidden = true; }, 220); }
    destravarRolagem();
  }

  var toastT;
  function toast(msg) {
    var el = $('[data-sc-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  function addToCart(vid, abrir, btn, qtd) {
    if (!vid) return;
    var q = Math.min(PDP_QTD_MAX, Math.max(1, Number(qtd) || 1));
    var rotuloOriginal = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = t('adding'); }
    return fetch(cartURL('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: q }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = t('added'); setTimeout(function () { btn.textContent = rotuloOriginal; }, 1400); }
        porQtdPDP(1);
        /* Adicionar pelo card ou pelo "adicionar ao carrinho" NAO abre o
           carrinho — so atualiza o contador. O "comprar agora" abre, porque
           ali a intencao e fechar. */
        if (abrir) openCart(); else toast(t('toast_added'));
      })
      .catch(function (e) {
        console.error('[supercacheada] add', e);
        if (btn) { btn.disabled = false; btn.textContent = rotuloOriginal; }
        toast(t('err_add'));
      });
  }

  function changeQty(key, qty) {
    return fetch(cartURL('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { aplicarCarrinho(c); })
      .catch(function (e) { console.error('[supercacheada] change', e); });
  }

  /* ---------- seletores de pais e idioma ---------------------------------- */
  function bindPicker(wrap) {
    if (!wrap) return;
    var btn = $('.sc-pick__btn', wrap);
    var menu = $('.sc-pick__menu', wrap);
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var aberto = !menu.hidden;
      fecharTodos();
      if (aberto) return;
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    });
    menu.addEventListener('click', function (e) { e.stopPropagation(); });
  }
  function fecharTodos() {
    $$('.sc-pick__menu').forEach(function (m) { m.hidden = true; });
    $$('.sc-pick__btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  /* O seletor de pais prefere a janela do app Orbe quando ele esta na pagina;
     a lista nativa fica como reserva e envia o formulario de localizacao do
     Shopify, que e quem sabe montar o endereco do mercado. */
  function tentarOrbe() {
    try {
      if (window.mdApp && typeof window.mdApp.openModal === 'function') { window.mdApp.openModal(); return true; }
      var gatilho = D.querySelector('[data-orbe-open], .orbe-selector-trigger, #orbe-selector');
      if (gatilho) { gatilho.click(); return true; }
    } catch (e) { /* segue para a lista nativa */ }
    return false;
  }

  /* ---------- faixa de divergencia de mercado ----------------------------- */
  /* O sinal vem da regiao declarada no idioma do navegador e, na falta dela,
     do fuso horario. SEM SINAL, NAO APARECE: o erro cai para o lado de nao
     incomodar. So aparece na divergencia — nunca um pop-up em todo acesso. */
  var TZ2CC = {
    'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US', 'America/Los_Angeles': 'US',
    'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'Europe/London': 'GB', 'Europe/Dublin': 'IE',
    'Europe/Lisbon': 'PT', 'Europe/Madrid': 'ES', 'Europe/Paris': 'FR', 'Europe/Berlin': 'DE',
    'Europe/Rome': 'IT', 'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE', 'Europe/Zurich': 'CH',
    'Europe/Vienna': 'AT', 'Europe/Stockholm': 'SE', 'Europe/Oslo': 'NO', 'Europe/Copenhagen': 'DK',
    'Asia/Tokyo': 'JP', 'Asia/Seoul': 'KR', 'Asia/Dubai': 'AE', 'Asia/Riyadh': 'SA', 'Asia/Jerusalem': 'IL',
    'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Pacific/Auckland': 'NZ', 'America/Mexico_City': 'MX'
  };
  function paisDoNavegador() {
    var langs = navigator.languages || [navigator.language];
    for (var i = 0; i < langs.length; i++) {
      var m = /[-_]([A-Za-z]{2})$/.exec(langs[i] || '');
      if (m) return m[1].toUpperCase();
    }
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz && TZ2CC[tz]) return TZ2CC[tz];
    } catch (e) { /* sem sinal */ }
    return null;
  }
  function marketHint() {
    var barra = $('[data-sc-hint]');
    if (!barra) return;
    try { if (sessionStorage.getItem('sc-hint-off') === '1') return; } catch (e) { /* segue */ }
    var atual = (CFG.country || '').toUpperCase();
    var sinal = paisDoNavegador();
    if (!sinal || !atual || sinal === atual) return;

    var form = $('#sc-country-form');
    var alvo = form ? $('button[value="' + sinal + '"]', form) : null;
    if (!alvo) return; /* a loja nao vende para esse pais: nao oferece nada */

    var nome = $('span', alvo);
    var nomeEl = $('[data-sc-hint-name]', barra);
    if (nomeEl) nomeEl.textContent = nome ? nome.textContent : sinal;
    var ir = $('[data-sc-hint-go]', barra);
    if (ir) ir.addEventListener('click', function (e) { e.preventDefault(); alvo.click(); });
    var x = $('[data-sc-hint-x]', barra);
    if (x) x.addEventListener('click', function () {
      barra.classList.remove('is-on');
      try { sessionStorage.setItem('sc-hint-off', '1'); } catch (e) { /* sem storage, some so nesta visita */ }
    });
    barra.classList.add('is-on');
  }

  /* ---------- faixa de produtos do hero -----------------------------------
     Duplicada uma vez no HTML para o laco de -50% fechar sem salto. Usa as
     mesmas fotos do catalogo, que sao #FFFFFF puro e por isso se integram ao
     fundo branco da faixa sem caixa nem recorte. */
  function montarFaixa() {
    var track = $('[data-sc-strip]');
    if (!track) return;
    var fotos = PRODUCTS
      .filter(function (p) { return familia(p) && p.img.length; })
      .map(function (p) { return { s: p.img[0].s, a: p.t }; });
    if (fotos.length < 4) { var s = track.closest('.sc-strip'); if (s) s.hidden = true; return; }
    var html = fotos.concat(fotos).map(function (f) {
      return '<img src="' + esc(f.s) + '" alt="' + esc(f.a) + '" loading="lazy" width="300" height="300">';
    }).join('');
    track.innerHTML = html;
  }

  /* ---------- ligacao ----------------------------------------------------- */
  function init() {
    paint();
    $$('[data-sc-grid]').forEach(function (g) {
      g.setAttribute('aria-busy', 'true');
      if (!g.textContent.trim()) g.innerHTML = '<p class="sc-nota">' + esc(t('loading')) + '</p>';
    });

    cartEl = $('[data-sc-cart]');
    veilEl = $('[data-sc-cart-veil]');
    bodyEl = $('[data-sc-cart-body]');
    footEl = $('[data-sc-cart-foot]');
    totalEl = $('[data-sc-cart-total]');
    countEl = $('[data-sc-count]');
    qdEl = $('[data-sc-cart-qd]');
    shipEl = $('[data-sc-cart-ship]');
    delEl = $('[data-sc-cart-del]');
    pdpOvl = $('[data-sc-pdp-ovl]');
    pdpBox = $('[data-sc-pdp]');

    renderGrids();
    montarFaixa();
    bindPicker($('[data-sc-lang]'));
    bindPicker($('[data-sc-country]'));

    var btnPais = $('[data-sc-country] .sc-pick__btn');
    if (btnPais) {
      btnPais.addEventListener('click', function (e) {
        if (tentarOrbe()) { e.stopImmediatePropagation(); fecharTodos(); }
      }, true);
    }

    D.addEventListener('click', fecharTodos);

    /* clique global: a ordem importa. Os controles internos da ficha vem
       ANTES dos botoes de compra, e os botoes de compra ANTES do card,
       porque o card inteiro tambem responde ao clique. */
    D.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-sc-var]');
      if (opt) {
        e.preventDefault(); e.stopPropagation();
        if (opt.disabled || !PDP.p) return;
        var nova = PDP.p.v.filter(function (v) { return Number(v.id) === Number(opt.dataset.scVar); })[0];
        if (nova) { PDP.v = nova; pintarVariante(); }
        return;
      }

      var passo = e.target.closest('[data-sc-pdp-step]');
      if (passo) {
        e.preventDefault(); e.stopPropagation();
        porQtdPDP(pdpQtd() + Number(passo.dataset.scPdpStep));
        return;
      }

      /* Na ficha a quantidade vem do seletor; no card da vitrine e sempre 1. */
      var add = e.target.closest('[data-sc-add]');
      if (add) {
        e.preventDefault(); e.stopPropagation();
        addToCart(add.dataset.scAdd, false, add, add.closest('.sc-pdp') ? pdpQtd() : 1);
        return;
      }

      var buy = e.target.closest('[data-sc-buy]');
      if (buy) {
        e.preventDefault(); e.stopPropagation();
        addToCart(buy.dataset.scBuy, true, buy, buy.closest('.sc-pdp') ? pdpQtd() : 1);
        return;
      }

      /* Produto com variante: o botao do card leva a ficha em vez de somar. */
      var abre = e.target.closest('[data-sc-open-handle]');
      if (abre) { e.preventDefault(); e.stopPropagation(); openPDP(abre.dataset.scOpenHandle); return; }

      var card = e.target.closest('.sc-card');
      if (card && card.dataset.scHandle) { openPDP(card.dataset.scHandle); return; }

      if (e.target.closest('[data-sc-cart-open]')) { openCart(); return; }
      if (e.target.closest('[data-sc-cart-close]')) { closeCart(); return; }
      if (e.target.closest('[data-sc-cart-veil]')) { closeCart(); return; }
      if (e.target.closest('[data-sc-pdp-close]')) { closePDP(); return; }
      if (e.target === pdpOvl) { closePDP(); return; }

      var th = e.target.closest('[data-sc-th]');
      if (th) {
        var i = Number(th.dataset.scTh);
        var main = $('[data-sc-main]');
        if (PDP.p && main && PDP.p.img[i]) {
          main.src = PDP.p.img[i].s;
          main.alt = PDP.p.img[i].a || PDP.p.t;
          $$('[data-sc-th]').forEach(function (b) { b.removeAttribute('aria-current'); });
          th.setAttribute('aria-current', 'true');
        }
        return;
      }

      var qty = e.target.closest('[data-sc-qty]');
      if (qty) {
        var linha = qty.closest('.sc-line');
        var atual = CART.items.filter(function (it) { return it.key === linha.dataset.key; })[0];
        if (atual) changeQty(atual.key, atual.quantity + Number(qty.dataset.scQty));
        return;
      }
      var rm = e.target.closest('[data-sc-rm]');
      if (rm) {
        var l2 = rm.closest('.sc-line');
        if (l2) changeQty(l2.dataset.key, 0);
        return;
      }
    });

    /* teclado: o card e uma div com role=button, entao Enter e Espaco
       precisam ser tratados na mao. */
    D.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        /* O popup da garantia e um checkbox: sem isto o Escape fechava a ficha
           e o carrinho e deixava a garantia aberta por cima da pagina. */
        var cbx = D.getElementById('sc-guar-cbx');
        if (cbx && cbx.checked) { cbx.checked = false; return; }
        closePDP(); closeCart(); fecharTodos(); return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      /* <label role="button" tabindex="0"> recebe foco mas NAO responde a
         teclado sozinho: o navegador so liga label ao controle no clique. */
      var lbl = e.target.closest && e.target.closest('label[for="sc-guar-cbx"]');
      if (lbl) { e.preventDefault(); var c = D.getElementById('sc-guar-cbx'); if (c) c.checked = !c.checked; return; }
      var card = e.target.closest && e.target.closest('.sc-card');
      if (card && card === e.target && card.dataset.scHandle) {
        e.preventDefault();
        openPDP(card.dataset.scHandle);
      }
    });

    fetchCart().then(marketHint);
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();
})();
